// De hoekafronding uit de huisstijl voor de vaste afrondingen in de widget (11-10-2026).
//
// theme.js zet --jm-hoek-schaal op de pagina: de ingestelde hoek gedeeld door de standaard (8px). Elke vaste afronding wordt
// daarmee vermenigvuldigd. Staat de hoek op de standaard, of heeft de winkel geen huisstijl (dan is de variabele er niet en
// geldt 1), dan blijft elke afronding precies wat hij was. Een grotere hoek maakt alles ronder, maar nooit meer dan 24px (de
// grootste hoek die je kunt kiezen) tenzij de afronding al groter was. Ronde dingen (50%, pillen van 40px en meer) gaan hier
// niet doorheen en blijven rond.

/** De standaardhoek van de merkkleuren (Merkkleuren.Hoekafronding): bij deze hoek verandert er niets. */
export const STANDAARDHOEK = 8;

/** De grootste hoek die je in de huisstijl kunt kiezen. */
export const GROOTSTEHOEK = 24;

/** De schaal bij een ingestelde hoek (0..24): 1 bij de standaard. */
export const hoekschaal = (hoek) => {
    const h = Number(hoek);
    if (!Number.isFinite(h)) return 1;
    return Math.max(0, Math.min(GROOTSTEHOEK, h)) / STANDAARDHOEK;
};

/** Een vaste afronding van px pixels die de hoek uit de huisstijl volgt. */
export const hoekMaat = (px) =>
    `min(calc(${px}px * var(--jm-hoek-schaal, 1)), ${Math.max(px, GROOTSTEHOEK)}px)`;
